<template>
  <div>
    <!-- Header Card -->
    <el-card class="mb-2" shadow="never">
      <div class="d-flex align-items-end">
        <div class="d-flex">
          <el-image
            :src="baseInfo.defaultImageUrl || '/image/static/img/nopic.jpg'"
            :preview-src-list="[
              baseInfo.defaultImageUrl || '/image/static/img/nopic.jpg',
            ]"
            style="width: 134px; height: 88px"
            fit="cover"
          >
            <div slot="error">
              <img
                src="/image/static/img/nopic.jpg"
                style="width: 120px; height: 80px"
              />
            </div>
          </el-image>
        </div>
        <div style="flex: 1;" class="ml-2">
          <h5 style="color: #101010;">
            {{ baseInfo.materialName || "-" }}
            &nbsp;
            {{ baseInfo.materialNameEn || "-" }}
          </h5>
          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              <div style="height: 29px;line-height: 29px;overflow: hidden;">
                <span style="font-size: 14px; color: #606266">
                  NO：{{
                    baseInfo.materialNo ||
                      $l("tips_materialNoAutoGenerate") ||
                      "物料编号自动生成"
                  }}
                </span>
                <el-divider direction="vertical" />
                <el-tag
                  size="mini"
                  :type="
                    baseInfo.materialStatus === 'Y'
                      ? 'success'
                      : baseInfo.materialStatus === 'N'
                      ? 'danger'
                      : ''
                  "
                >
                  {{ baseInfo.v_materialStatus || "New" }}
                </el-tag>
                <el-divider direction="vertical" />
                <span style="font-size: 14px; color: #606266">
                  {{ $l("form_label_update_time") || "最新更新" }}
                  :{{ baseInfo.modifyByName || "--" }} at
                  {{ baseInfo.modifyDate || "--" }}
                </span>
              </div>
            </div>
            <div>
              <el-button
                v-if="!isAddOperation && !isInvalid"
                size="small"
                @click="handleEdit"
              >
                {{ $l("INDEX.btn_edit") || "编辑" }}
              </el-button>
              <el-button
                v-if="!isAddOperation && !isInvalid"
                size="small"
                @click="handleDelete"
              >
                {{ $l("INDEX.btn_delete") || "删除" }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <!-- Form Card -->
    <el-card shadow="never" class="form-card">
      <div class="clearfix" slot="header">
        <span class="section-title">{{
          $l("form_label_material_info") || "物料信息"
        }}</span>
        <el-button
          v-if="!isDisableEditForm"
          class="save-btn"
          size="small"
          type="primary"
          plain
          @click="() => $refs.editForm.save()"
        >
          {{ $l("INDEX.btn_save") || "保存" }}
        </el-button>
      </div>
      <edit-form
        :disabled="isDisableEditForm"
        :productLine="params.productLine"
        :materialCode="params.materialCode"
        :pageType="this.pageType"
        ref="editForm"
        @loaded="onFormLoaded"
      />
    </el-card>

    <!-- Bottom Section: Sample Images & Doc Files -->
    <el-row :gutter="24" class="mt-2">
      <el-col :span="8">
        <el-card shadow="never" class="bottom-card">
          <div class="clearfix" slot="header">
            <span class="section-title">{{
              $l("table_label_sample_image") || "样张图片"
            }}</span>
            <el-button
              v-if="!isDisableEditForm"
              class="save-btn"
              size="small"
              type="primary"
              plain
              :disabled="!isAddOperation && !params.materialCode"
              @click="() => $refs.sampleImages.openEditDialog()"
            >
              {{ $l("btn_edit_image") || "编辑图片" }}
            </el-button>
          </div>
          <sample-images
            ref="sampleImages"
            :materialCode="params.materialCode"
            :disabled="isAddOperation || isDisableEditForm"
            @reload="reloadInfoImage"
          />
        </el-card>
      </el-col>
      <el-col :span="16">
        <el-card shadow="never" class="bottom-card">
          <div class="clearfix" slot="header">
            <span class="section-title">{{
              $l("table_label_description_file") || "说明文件"
            }}</span>
            <el-button
              v-if="!isDisableEditForm"
              class="save-btn"
              size="small"
              type="primary"
              plain
              :disabled="!isAddOperation && !params.materialCode"
              @click="() => $refs.docFiles.uploadFile()"
            >
              {{ $l("btn_upload_file") || "上传文件" }}
            </el-button>
          </div>
          <doc-files
            ref="docFiles"
            :materialCode="params.materialCode"
            :disabled="isAddOperation || isDisableEditForm"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import EditForm from "../components/edit-form";
import SampleImages from "./components/sample-images";
import DocFiles from "./components/doc-files";
export default {
  name: "material-materialInfoSet-detail",
  components: {
    EditForm,
    SampleImages,
    DocFiles,
  },
  data() {
    return {
      baseInfo: {},
    };
  },
  activated() {
    this.baseInfo = {};
  },
  computed: {
    params() {
      return this.$route.params;
    },
    pageType() {
      return this.params.pageType;
    },
    pageHeader() {
      const types = {
        edit:
          this.$l("page_header_edit_material_information") || "编辑物料信息",
        add: this.$l("page_header_add_material_information") || "添加物料信息",
        detail:
          this.$l("page_header_material_information_details") || "物料信息详情",
      };
      return types[this.pageType];
    },
    isDisableEditForm() {
      return this.pageType === "detail";
    },
    isAddOperation() {
      return this.pageType === "add";
    },
    isInvalid() {
      return this.baseInfo.materialStatus === "N";
    },
  },
  methods: {
    onFormLoaded(data) {
      this.baseInfo = data;
    },
    reloadInfoImage() {
      if (this.$refs.editForm) {
        this.$refs.editForm.reloadInfoImage();
      }
    },
    handleEdit() {
      this.$router.replace({
        name: "material-materialInfoSet-detail",
        params: {
          pageType: "edit",
          materialCode: this.params.materialCode,
          productLine: this.params.productLine,
        },
      });
    },
    handleDelete() {
      this.$confirm(
        this.$l("INDEX.tips_delete") || "是否要删除该记录？",
        this.$l("INDEX.label_completeDesc") || "确认信息",
        {
          confirmButtonText:
            this.$l("INDEX.product_dialog_btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: "warning",
        }
      ).then(() => {
        this.$api
          .materialInfoDelApi({ materialCode: this.params.materialCode })
          .then((res) => {
            if (res.status === 200) {
              this.$message({
                showClose: true,
                message: this.$l("INDEX.tips_delete_ok") || "删除成功！",
                type: "success",
              });
              this.$router.go(-1);
            }
          });
      });
    },
    save() {
      this.$refs.editForm.save();
    },
  },
};
</script>
<style lang="scss" scoped>
.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  position: relative;
}

.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 18px;
  margin-right: 8px;
}

.section-title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.save-btn {
  float: right;
}

.bottom-card {
  min-height: 300px;
}

::v-deep {
  .el-card__body {
    padding: 18px;
  }

  .form-card,
  .bottom-card {
    border: 1px dashed #dcdfe6;
  }
}
</style>
